import {makeObservable, observable} from 'mobx';
import * as ls from 'local-storage'
import {Locale} from "../models/locale";
import {DEFAULT_LOCALE} from "../LocalesProvider";

type AuthData = {
  authToken: string
  accessToken: string
  refreshToken: string
  userShort: string
}

class AppStateStore {
  authData?: AuthData;
  activeView?: string;
  // Pinned, not detected. Deliberately ignores localStorage `i18nextLng` so a
  // stale es-MX from before the picker was removed can't resurrect a Spanish
  // locale against an English-only backend. See LocalesProvider.
  activeLocale: Locale = DEFAULT_LOCALE

  persistAuthData = (authData: AuthData) => {
    ls.set('authData', JSON.stringify(authData))
    this.authData = authData
  }

  restoreAuthData = () => {
    try {
      this.authData = JSON.parse(ls.get('authData'))
    } catch (e) {
      console.log(e)
    }
  }

  clearAuthData = () => {
    this.authData = undefined
    ls.remove('authData')
  }

  getAuthData = () => {
    this.restoreAuthData();
    return this.authData
  }

  constructor() {
    makeObservable(this, {
      authData: observable,
      activeView: observable,
      activeLocale: observable,
    });
  }
}

const state = new AppStateStore()

export default state as AppStateStore
